export const DEFAULT_SEQUOIA_PHONE_NUMBER = "8774178733";
export const DEFAULT_SEQUOIA_DATE_OF_BIRTH = "1900-01-01";
export const DEFAULT_SEQUOIA_EMAIL_PREFIX = "policyholder+";
export const DEFAULT_SEQUOIA_EMAIL_DOMAIN = "@covertree.com";
